import { useMemo } from 'react';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  type ParsedStore,
  useAvailableStoresAsyncAtom,
} from '@service-initiation/tech-care-data-access-store';

type StoresAndLoadingState = {
  loading: boolean;
  stores?: ParsedStore[];
};

export const useStores = (): StoresAndLoadingState => {
  const {
    error: storesStateError,
    loading: storesStateLoading,
    value: storesStateValue,
  } = useAvailableStoresAsyncAtom();
  const {
    error: storesAndAvailabilityStateError,
    loading: storesAndAvailabilityStateLoading,
    value: storesAndAvailabilityStateValue,
  } = useAvailableStoresAsyncAtom(true);

  const value = useMemo(() => {
    if (
      !storesAndAvailabilityStateLoading &&
      !storesStateLoading &&
      (storesAndAvailabilityStateError || storesStateError)
    ) {
      const err = new Error(
        'Error occurred while trying to initiate stores and appointments'
      );
      logger.error(err);
      return { loading: false, stores: [] };
    } else {
      if (storesStateValue && storesAndAvailabilityStateLoading) {
        return {
          loading: storesStateLoading,
          stores: storesStateValue,
        };
      }

      return {
        loading: storesAndAvailabilityStateLoading,
        stores: storesAndAvailabilityStateValue,
      };
    }
  }, [
    storesAndAvailabilityStateError,
    storesAndAvailabilityStateLoading,
    storesAndAvailabilityStateValue,
    storesStateError,
    storesStateLoading,
    storesStateValue,
  ]);

  return value;
};
